import { forwardRef, type Ref, type SVGProps } from "react";

function SvgArrowRight(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.333 3.667 13.667 8l-4.334 4.333m4-4.333h-11"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
